<template>
    <li class="relative">
        <button
            @click="togglePinToTray"
            :class="{
                'border-v2-green bg-v2-green/5 dark:border-v2-green dark:bg-v2-green/5': isInTray,
                'border-keyline-primary': !isInTray
            }"
            class="
                border 
                flex 
                gap-3 
                items-center 
                leading-none 
                max-w-full 
                rounded 
                text-v2-gray-20 
                text-left 
                w-full 
                hover:border-keyline-primary-invert 
                bg-gray-120 
                dark:bg-gray-700 
                dark:text-v2-gray-130 
                hover:dark:border-v2-gray-90 
                hover:dark:text-v2-white
            "
        >
            <span class="sr-only">Pin to</span>
            <!-- The Tray's representative image. -->
            <span
                aria-hidden="true"
                class="flex items-center justify-center shrink-0 size-[60px] border-r border-keyline-primary"
            >
                <LoadingSpinner v-if="loading" class="size-4" />
                <!-- If Favorites. -->
                <BaseSvg v-else-if="tray.name === 'Favorites'" name="HeartOutlineThick" class="inline-block max-w-none size-6 fill-tertiary"/>
                <!-- If a NEW/empty tray. -->
                <span v-else-if="tray.isNew" class="font-medium text-[12px] text-v2-gray-20 uppercase dark:text-v2-gray-90">New</span>
                <BaseSvg v-else name="icon-pin-tray-thick" alt="" class="inline-block max-w-none size-6 fill-tertiary"/>
            </span>
            <span class="flex flex-col overflow-hidden mr-16">
                <span>
                    <!-- Tray name. -->
                    <span class="leading-none mr-1">{{ tray.name }}</span>
                    <!-- Tray's pinned quantity. -->
                    <span class="leading-none text-xs text-v2-gray-90">({{ tray.pin_count }} {{useHelpers().pluralize(tray.pin_count, 'pin', 'pins')}})</span>
                </span>
                <!-- <span v-if="tray?.description" aria-hidden="true" class="text-xs text-v2-gray-80 truncate">{{ tray.description }}</span> -->
            </span>
            <!-- Check mark when product is in tray -->
            <span v-if="isInTray" ref="checkMark" class="absolute right-3 top-1/2 transform -translate-y-1/2" aria-hidden="true">
                <BaseSvg name="Check" class="fill-v2-green size-5" />
            </span>
        </button>
        <!-- When an item is added to this tray, add class `confirmation-run` -->
        <span ref="flashSpan" class="confirmation-ready" aria-hidden="true">
            <BaseSvg name="Check" aria-hidden="true" class="size-4"/>
            {{ message }}
        </span>
    </li>
</template>

<script setup>
import {onMounted, ref, computed} from "vue";
import {BaseSvg, LoadingSpinner} from "@/Components";
import {eventBus, useHelpers, usePinsDrawer} from "@/Composables";

const props = defineProps(['tray','id','type','currentPin']);
const emits = defineEmits(["toggle-pin"]);

const { handlePinToTray } = usePinsDrawer();

const flashSpan = ref(null);
const checkMark = ref(null);
const message = ref('Added');
const loading = ref(false);
// Check if the current product is already in this tray
const isInTray = computed(() => {
    if (!props.currentPin || !props.currentPin.trays) {
        return false;
    }
    return props.currentPin.trays.some(tray => tray.name === props.tray.name);
});

async function togglePinToTray() {
    try {
        loading.value = true;
        const response = await handlePinToTray(props.type, props.id, props.tray.name)

        const trays = response.data.pin.trays || []
        const isNowInTray = trays.some(t => t.name === props.tray.name)

        message.value = isNowInTray ? 'Added' : 'Removed';

        // Update the current pin data with the new state
        emits('toggle-pin', response.data.pin);

        flashSuccess(message.value)
    } catch (e) {
        console.log('Error:', e);
    } finally {
        loading.value = false;
    }
}

function flashSuccess() {
    if (!flashSpan.value) return

    flashSpan.value?.classList.add('confirmation-run');
    setTimeout(() => {
        flashSpan.value?.classList.remove('confirmation-run');
    }, 3000)
}

onMounted(() => {
    eventBus.emit('pins:fetch')
})
</script>
